import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    const exchange = async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/google-session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        navigate("/admin", { state: { user: data }, replace: true });
      } catch (e) {
        const detail = e.response?.data?.detail;
        navigate("/admin", {
          state: { authError: typeof detail === "string" ? detail : "Google sign-in failed." },
          replace: true,
        });
      }
    };
    exchange();
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
      <p className="font-plex text-xs uppercase tracking-[0.3em] text-white/50">
        Verifying founder access…
      </p>
    </div>
  );
};

export default AuthCallback;
